import {
  Box,
  CloseButton,
  HStack,
  IconButton,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  LoadingOverlay,
  MonthPicker,
  NumberInput,
} from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { fieldNumberModelToInputProps } from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import type { OurWorkProgressBarStore } from "../store";

type OurWorkProgressBarPopoverContentProps = {
  store: OurWorkProgressBarStore;
};

export const OurWorkProgressBarPopoverContent = observer(
  function OurWorkProgressBarPopoverContent({
    store,
  }: OurWorkProgressBarPopoverContentProps) {
    return (
      <PopoverContent minW="fit-content" onClick={(e) => e.stopPropagation()}>
        <PopoverHeader>
          <HStack justify="space-between">
            <Text fontSize="lg">
              <Trans>Edit progress</Trans>
            </Text>
            <CloseButton onClick={store.disclosure.onClose} />
          </HStack>
        </PopoverHeader>

        <PopoverBody>
          <LoadingOverlay
            isLoading={store.isPeriodsLoading}
            transparent={false}
            size="md"
          >
            <Stack
              justify="space-between"
              direction={{ base: "column", md: "row" }}
              spacing="2"
            >
              {store.currentPeriod && (
                <MonthPicker
                  disablePopover
                  value={store.currentPeriod}
                  onChange={({ id }) => void store.handlePeriodChange(id)}
                  options={store.periodsStore.options}
                />
              )}
              <LoadingOverlay
                isLoading={store.isPeriodLoading}
                size="sm"
                position="absolute"
              >
                <Box minW="24">
                  <NumberInput
                    suffix="%"
                    minValue={0}
                    maxValue={100}
                    disabled={store.periodDisabled}
                    {...fieldNumberModelToInputProps(store.progressField)}
                  />
                </Box>
              </LoadingOverlay>
              <IconButton
                aria-label={t`Submit progress`}
                icon={<Icon name="check" />}
                isDisabled={store.periodDisabled || !store.canSubmitProgress}
                isLoading={store.isSubmitLoading}
                onClick={() => void store.submit()}
                type="submit"
              />
            </Stack>
          </LoadingOverlay>
        </PopoverBody>
      </PopoverContent>
    );
  },
);
